var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-right pr-3 mx-auto"},[_c('div',{staticClass:"content"},[_c('b-img',{staticClass:"img_paciente p-2 mx-auto py-auto",attrs:{"src":require("@/assets/paciente.png")}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }